<template>
  <div class="explain">
    <h6 class="semibold">
      {{ title }}
    </h6>
    <p v-html="description"></p>
  </div>
</template>

<script>
export default {
  name: 'ProductExplanation',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    title() {
      return {
        'nominale':
          'Affidati all’esperienza di Quattroruote per conoscere il reale valore del veicolo: a soli 3,99 € ottieni la Quotazione più aggiornata e affidabile sul mercato.',
        'sponsor':
          'Affidati all’esperienza di Quattroruote per conoscere il reale valore del veicolo: a soli 3,99 € ottieni la Quotazione più aggiornata e affidabile sul mercato.',
        'live-market':
          'Affidati all’esperienza di Quattoruote, ottieni il Report Live Market a soli 9,99 €',
        'storica':
          'Affidati all’esperienza di Quattroruote per conoscere il reale valore del veicolo ad una specifica data nel passato: a soli 23,99€ ottieni la quotazione!',
        'ruote-classiche':
          'Affidati all’esperienza di Quattroruote per conoscere il reale valore del veicolo con valenza storica o collezionistica: a soli 5,99€ ottieni la quotazione!',
      }[this.type];
    },
    description() {
      return {
        'nominale': `La Quotazione Quattroruote fornisce una valutazione approssimativa del valore di mercato del
                veicolo, utilizzando analisi statistiche e rilevazioni di mercato per offrire un valore
      aggiornato. <br />
      Puoi ottenere un certificato, utile per determinare il valore per vendere, acquistare e
      assicurare il veicolo selezionato. <br />
      L’attestato comprende: la quotazione per vendere, che considera le caratteristiche del veicolo
      per massimizzarne il valore; per comprare, che tiene conto delle caratteristiche principali
      del veicolo e offre consigli utili agli acquirenti; ed infine, per assicurare, <br />
      che fornisce un valore di confronto per il rinnovo della polizza incendio e furto. Questo
      valore è utilizzato dalle assicurazioni per calcolare il premio.`,
        'sponsor': `La Quotazione Quattroruote fornisce una valutazione approssimativa del valore di mercato del
                veicolo, utilizzando analisi statistiche e rilevazioni di mercato per offrire un valore
      aggiornato. <br />
      Puoi ottenere un certificato, utile per determinare il valore per vendere, acquistare e
      assicurare il veicolo selezionato. <br />
      L’attestato comprende: la quotazione per vendere, che considera le caratteristiche del veicolo
      per massimizzarne il valore; per comprare, che tiene conto delle caratteristiche principali
      del veicolo e offre consigli utili agli acquirenti; ed infine, per assicurare, <br />
      che fornisce un valore di confronto per il rinnovo della polizza incendio e furto. Questo
      valore è utilizzato dalle assicurazioni per calcolare il premio.`,
        'live-market':
          'Integra alla Quotazione Quattroruote una panoramica del posizionamento della tua auto sul mercato, attraverso una nuova elaborazione dei dati raccolti dai principali portali di annunci di auto usate. Il Report Live Market presenta i valori ottenuti dall’elaborazione dei dati raccolti sui principali portali di compravendita di auto usate a livello nazionale, offrendo una fotografia istantanea del posizionamento del veicolo in questione. L’attestato Quotazioni Live Market fornisce una visione unica e integrata per offrire informazioni immediate, complete e di alta qualità. Puoi ottenere un certificato utile a determinare il valore per vendere, acquistare e assicurare il veicolo selezionato.',
        'storica':
          'La Quotazione Storica fornisce una valutazione utile per richiedere un risarcimento danni o furto occorsi in periodi precedenti. Le Quotazioni sono utilizzate in diversi contesti e si adattano alle esigenze specifiche, come quelle delle assicurazioni, trattative commerciali, e permute.',
        'ruote-classiche':
          'La Quotazione Ruote Classiche consente di ottenere un certificato che contiene la valutazione di un veicolo con significato storico o collezionistico, fornendo una stima approssimativa del suo valore di mercato tramite l’utilizzo di statistiche e rilevazioni di mercato per garantire un valore aggiornato. Puoi ottenere un certificato che ti aiuta a valutare il valore del veicolo in base a criteri specifici e dettagliati, considerando il suo stato di conservazione, integrità, originalità, presenza di danni alla carrozzeria o condizioni di relitto.',
      }[this.type];
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/ProductExplanation.vue